// extracted by mini-css-extract-plugin
export default {"page":"styles_page__LTck1","head":"styles_head__jqZP3","buttons":"styles_buttons__ISekl","canvas":"styles_canvas__fIZUb"};